import request from "@/service/index";

const logout = (context, payload) => {
  context.commit(payload.type);

  // Remove notification when log out
  /*
  try {
    getToken(firebaseMessaging, {
      vapidKey: "BKS5Fn3_uJY7O-OiPVvnGYCOC2L_AZLc6rRYToFicerjIYrRcX4CMyFuJDrZ-Qxg7dOUf8Hf2Fd-AnJmdmGQ67I",
    })
      .then((currentToken) => {
        if (currentToken) {
          request("POST", "notification/logoutToken", {
            fcm_token: currentToken,
          });
        }
      })
      .catch((err) => {});
  } catch (e) {
    console.log("Could not get firebase token", e);
  }
  */
};

const setUserID = (context, payload) => {
  context.commit(payload.type, payload.userID);
};

const getMeInfo = async (context, payload) => {
  try {
    if (window.localStorage.token) {
      const response = await request("GET", `users/aboutme`);
      // if (response.data.trial == 0) {
      //   window.trialExpired();
      // }
      context.commit(payload.type, {
        user_id: response.data.userID,
        me: response.data,
      });

      // Produktly
      try {
        let channel = "";
        if (window.location.origin == "http://localhost:8080") channel = "LOCAL";
        else if (window.location.origin == "https://dev.callendo.com") channel = "DEV";
        else channel = "PROD";
        let user = response.data;
        let d = {
          tool: "callendo",
          channel: channel,
          account_type: user.account_type,
          lifetime: user.lifetime,
          plan_type: user.plan_type,
          quantity: user.quantity,
          referrer: user.referrer,
          reg_date: user.regDate,
          reg_time: user.regtime,
          email: user.userEmail,
          user_id: user.userID,
          phone: user.userPhone,
          email_confirmation: user.userStatus,
        };

        if (user.subscription) {
          d = {
            ...d,
            subscription_canceled: user.subscription.canceled,
            subscription_description: user.subscription.description,
            subscription_id: user.subscription.id,
            subscription_plan_type: user.subscription.plan_type,
            subscription_price: user.subscription.price,
            subscription_subid: user.subscription.subscription_id,
            subscription_created: user.subscription.sub_created,
            subscription_start: user.subscription.sub_start,
            subscription_end: user.subscription.sub_end,
          };
        }

        // window.Produktly.identifyUser(user.userID, d);
      } catch {}
    }
  } catch (error) {
    console.log("Error in getMeInfo action:", error);
  }
};

const updateMeInfo = (context, payload) => {
  context.commit(payload.type, payload.change);
};

const schedulingSettings = (context, payload) => {
  context.commit(payload.type, payload);
};

const schedulingAvailability = (context, payload) => {
  context.commit(payload.type, payload);
};

const schedulingEvents = (context, payload) => {
  context.commit(payload.type, payload);
};

const integrations = (context, payload) => {
  context.commit(payload.type, payload);
};

const invitations = (context, payload) => {
  context.commit(payload.type, payload);
};

const organization = (context, payload) => {
  context.commit(payload.type, payload);
};

const requests = (context, payload) => {
  context.commit(payload.type, payload);
};

export default {
  logout,
  setUserID,
  getMeInfo,
  updateMeInfo,
  schedulingSettings,
  schedulingAvailability,
  schedulingEvents,
  integrations,
  invitations,
  organization,
  requests,
};
